import { ChevronDownIcon } from "@/Icons";
import { Component } from "react";

class Accordion extends Component {

     constructor(props) {
          super(props);
          this.state = {
               isAccordionOpen: props.defaultOpen || true
          }
     }

     handleOnClick = () => {
          this.setState({ isAccordionOpen: !this.state.isAccordionOpen })
     }

     render() {
          const isDisabled = !!this.props.disabled
          const {isAccordionOpen} = this.state
          return (
               <div disabled={isDisabled} className={`accordion-card flex flex-col rounded-2xl px-8 py-6 gap-6 duration-300 ease-in-out ${this.props.className}`}>
                    <div className=' w-full flex h-8 justify-between items-center  '>
                         <p className=' text-16 font-semibold'>{this.props.title}</p>
                         {this.props.expandIcon && <div onClick={isDisabled ? () => { } : this.handleOnClick} className={`duration-300 ease-in-out ${this.state.isAccordionOpen ? "rotate-180" : "rotate-0"}`}> {this.props.expandIcon}</div>}
                    </div>
                   {isAccordionOpen && this.props.children?.props?.children}
               </div>
          )
     }
}

Accordion.defaultProps = {
     expandIcon: <ChevronDownIcon/>
 };
export default Accordion